import React, { useState, useEffect } from 'react';
import { Modal, Form, Select, Typography, Space, Button } from 'antd';
import { EnvironmentOutlined, UserOutlined } from '@ant-design/icons';
import { useZonas } from '../../../hooks/useZonas';
import { useClientes } from '../../../hooks/useClientes';

const { Text, Title } = Typography;

const ModalSeleccionarClientePedido = ({
  isOpen,
  onClose,
  zonaActiva,
  setZonaActiva,
  clienteSeleccionado,
  setClienteSeleccionado
}) => {
  const { zonas = [] } = useZonas();
  const { data: clientes = [] } = useClientes();
  const [form] = Form.useForm();

  const [idZonaTemp, setIdZonaTemp] = useState(null);

  useEffect(() => {
    if (isOpen) {
      // 1. Obtener la zona guardada previamente en localStorage o la activa
      const savedZonaId = zonaActiva?.id || localStorage.getItem('yugonub_zona_activa');
      const zonaInicialId = savedZonaId ? Number(savedZonaId) : null;

      setIdZonaTemp(zonaInicialId);

      form.setFieldsValue({
        zona_id: zonaInicialId,
        cliente_id: clienteSeleccionado && clienteSeleccionado.id !== 'DEFAULT' ? Number(clienteSeleccionado.id) : undefined
      });
    }
  }, [isOpen, zonaActiva, clienteSeleccionado, form]);

  // Filtrar clientes pertenecientes a la zona elegida
  const clientesDeZona = clientes.filter(c => {
    if (!idZonaTemp) return true; // Si no hay zona seleccionada, muestra todos
    return Number(c.zona_id) === Number(idZonaTemp);
  });

  const handleZonaChange = (value) => {
    setIdZonaTemp(value ? Number(value) : null);
    // Limpiar el cliente al cambiar de zona
    form.setFieldsValue({ cliente_id: undefined });
  };

  const handleConfirmar = (values) => {
    // Buscar objetos completos
    const zonaObjeto = zonas.find(z => Number(z.id) === Number(values.zona_id));
    const clienteObjeto = clientes.find(c => Number(c.id) === Number(values.cliente_id));

    if (zonaObjeto) {
      setZonaActiva(zonaObjeto);
      localStorage.setItem('yugonub_zona_activa', zonaObjeto.id);
    } else {
      setZonaActiva(null);
      localStorage.removeItem('yugonub_zona_activa');
    }

    if (clienteObjeto) {
      setClienteSeleccionado(clienteObjeto);
    }

    onClose();
  };

  return (
    <Modal
      open={isOpen}
      onCancel={onClose}
      footer={null}
      centered
      width={480}
      title={
        <Space>
          <EnvironmentOutlined style={{ color: '#f59e0b', fontSize: '20px' }} />
          <Title level={4} style={{ margin: 0, fontSize: '18px' }}>
            Seleccionar Zona y Cliente
          </Title>
        </Space>
      }
    >
      <Form form={form} layout="vertical" onFinish={handleConfirmar} style={{ marginTop: '16px' }}>
        
        {/* SELECTOR DE ZONA */}
        <Form.Item
          name="zona_id"
          label={<Text strong style={{ fontSize: '13px', color: '#475569' }}>📍 ZONA / RUTA DE ENTREGA</Text>}
        >
          <Select
            size="large"
            placeholder="Todas las zonas (General)"
            onChange={handleZonaChange}
            allowClear
            style={{ borderRadius: '10px' }}
            options={[
              { value: null, label: 'Todas las Zonas (General)' },
              ...zonas.map(z => ({
                value: Number(z.id),
                label: `📍 ${z.nombre} ${z.descripcion ? `(${z.descripcion})` : ''}`
              }))
            ]}
          />
        </Form.Item>

        {/* SELECTOR DE CLIENTES (FILTRADO POR ZONA) */}
        <Form.Item
          name="cliente_id"
          label={<Text strong style={{ fontSize: '13px', color: '#475569' }}>👤 CLIENTE *</Text>}
          rules={[{ required: true, message: 'Selecciona un cliente para la orden' }]}
        >
          <Select
            size="large"
            showSearch
            placeholder={idZonaTemp ? "Buscar cliente en esta zona..." : "Buscar cliente..."}
            optionFilterProp="label"
            style={{ borderRadius: '10px' }}
            options={clientesDeZona.map(c => ({
              value: Number(c.id),
              label: `${c.nombre_comercial ? `${c.nombre_comercial} (${c.nombre})` : c.nombre} ${c.documento ? `- ${c.documento}` : ''}`
            }))}
            locale={{ emptyText: 'No hay clientes registrados en esta zona.' }}
          />
        </Form.Item>

        <Button
          type="primary"
          htmlType="submit"
          block
          size="large"
          style={{
            backgroundColor: '#f59e0b',
            borderColor: '#f59e0b',
            height: '48px',
            borderRadius: '10px',
            fontWeight: '700',
            marginTop: '12px',
            fontSize: '15px'
          }}
        >
          CONFIRMAR CLIENTE Y ZONA
        </Button>
      </Form>
    </Modal>
  );
};

export default ModalSeleccionarClientePedido;